@if(componentModel){
    <a class="rounded-lg bg-card shadow overflow-hidden block min-w-60"
       [attr.href]="componentModel?.link?.value || null"
       [ngClass]="{
        'hover:bg-card-hover': componentModel?.link?.value
    }">
        <img loading="lazy"  [src]="componentModel?.image?.value" class="aspect-[14/13] w-full rounded-2xl object-cover" [alt]="componentModel.title.value">
        <h3 class="mt-6 text-lg/8 font-semibold tracking-tight text-white md:px-4 px-2">{{componentModel?.title?.value}}</h3>
        <p class="text-base/7 text-normal md:px-4 px-2">{{componentModel?.description?.value}}</p>
        <p class="text-sm/6 text-gray-500 md:px-4 px-2 mb-2">{{componentModel?.metaData?.value}}</p>
    </a>
}
